import { useEffect, useRef } from "react";

export const useInactivityLogout = (onLogout, timeout = 10 * 60 * 1000) => {
  const timerRef = useRef();

  const resetTimer = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      const timestamp = Date.now().toString();
      localStorage.setItem("forceLogout", timestamp);

      window.dispatchEvent(
        new StorageEvent("storage", { key: "forceLogout", newValue: timestamp })
      );
    }, timeout);

    localStorage.setItem("resetInactivity", Date.now().toString());
  };

  useEffect(() => {
    const events = ["mousemove", "keydown", "click", "scroll"];
    events.forEach((event) => window.addEventListener(event, resetTimer));
    resetTimer();

    const handleStorage = (e) => {
      if (e.key === "resetInactivity") {
        resetTimer();
      }

      if (e.key === "forceLogout") {
        onLogout();
      }
    };

    window.addEventListener("storage", handleStorage);

    return () => {
      events.forEach((event) => window.removeEventListener(event, resetTimer));
      window.removeEventListener("storage", handleStorage);
      clearTimeout(timerRef.current);
    };
  }, [timeout]);

  return { resetTimer };
};